<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-2"> </p>
<p class="Title02">M</p>
<p class="Title02">A</p>
<p class="Title02">G</p>
<p class="Title02">M</p>
<p class="Title02">A</p>
<p class="Author01">THÓRA HJÖRLEIFSDÓTTIR</p>
<p class="Author ParaOverride-1"><span class="CharOverride-1">Translated from the Icelandic by</span></p>
<p class="Author ParaOverride-2"><span class="CharOverride-2">Meg Matich</span></p>
<p class="BT1stPara ParaOverride-3"><img alt="" class="_idGenObjectAttribute-1" src="image/BlackCat.png"/></p>
<p class="BT1stPara ParaOverride-4"><span class="CharOverride-3">Black Cat</span></p>
<p class="BT1stPara ParaOverride-4"><span class="CharOverride-4">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802157409-1.vue?6ff701f6